import script from "./MallProductBuyPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallProductBuyPanel.vue?vue&type=script&setup=true&lang=ts"

import "../../pages/mall/MallProductPage.scss?vue&type=style&index=0&lang=scss&external"
import "./MallProductBuyPanel.scss?vue&type=style&index=1&lang=scss&external"

const __exports__ = script;

export default __exports__